// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2gH1A","content":"styles_content__4kZ_D","checkbox":"styles_checkbox__1Cnpu","checkboxLabel":"styles_checkboxLabel__1e8LU"};